import styled from 'styled-components';

export const BtnArrow = styled.div`
  height: calc(18px * 0.7);
  width: 18px;
  margin-left: auto;

  > svg {
    fill: ${Styles.color.grey.one};
    height: 100%;
    width: auto;
  }
`;
